import { isAvatarMenuMobile } from '../utils/avatarMenuMode.js';
import { getScreenWidth } from '../utils/getScreenWidth.js';

// @todo TM-7783 remove after the business account MVP is validated
const CORPORATE_BUSINESS_LINK_NAMES = ['corporateBusinessJoin', 'corporateBusinessDashboard'];

function isCorporateBusinessLink(link) {
  return CORPORATE_BUSINESS_LINK_NAMES.includes(link.name);
}

function splitLinks(links, firstInDropdown) {
  const navLinks = [];
  const dropdownLinks = [];

  links.forEach((link) => {
    const startedAddingToDropdown = dropdownLinks.length > 0;
    const addToDropdown = firstInDropdown === 'ALL' || link.name === firstInDropdown || startedAddingToDropdown;

    if (addToDropdown) {
      dropdownLinks.push(link);
    } else {
      navLinks.push(link);
    }
  });

  return { navLinks, dropdownLinks };
}

function getLinksPosition({ links, user, config }) {
  const width = getScreenWidth();

  const userConfig = config[user.type];
  let firstInDropdown = '';
  let dotAllowed = true;

  userConfig.forEach(({ width: breakpointWidth, firstElementInDropdown, dotAllowed: allowDot }) => {
    if (width > breakpointWidth) {
      firstInDropdown = firstElementInDropdown;
      dotAllowed = allowDot;
    }
  });

  // Where the avatar menu is the full-screen sheet it is the page's only navigation, so a header that
  // keeps the sheet on a tablet lays its links out there as the narrowest screen does.
  if (isAvatarMenuMobile()) {
    const [narrowest] = userConfig;
    firstInDropdown = narrowest.firstElementInDropdown;
    dotAllowed = narrowest.dotAllowed;
  }

  let { navLinks, dropdownLinks } = splitLinks(links, firstInDropdown);

  // The Tagvenue Business entry renders as a wide CTA button, so the header overflows next
  // to the logo and the search box long before the regular breakpoints would collapse it.
  // Below corporateBusinessMinWidth it moves into the avatar dropdown, which leaves the
  // header exactly as it looked before the MVP.
  // @todo TM-7783 remove after the business account MVP is validated
  const corporateBusinessMinWidth = config.corporateBusinessMinWidth;
  const inlineCorporateBusinessLink = navLinks.find(isCorporateBusinessLink);

  if (corporateBusinessMinWidth && width <= corporateBusinessMinWidth && inlineCorporateBusinessLink) {
    firstInDropdown = inlineCorporateBusinessLink.name;
    ({ navLinks, dropdownLinks } = splitLinks(links, firstInDropdown));
  }

  return { navLinks, dropdownLinks, dotAllowed };
}

export default getLinksPosition;
